import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { AuthService } from '@nrwl/rx-service-auth';
import { Injectable, inject } from '@angular/core';
import { of } from 'rxjs';
import {
  loginAttempted,
  loginSuccessful,
  loginFailed,
  ssoLogin,
  ssoLoginSuccessful,
  logoutSuccessful,
} from './auth.actions';
import { FeatureFlagsStore } from '@nrwl/rx-state-feature-flags';

@Injectable()
export class AuthEffects {
  private actions$ = inject(Actions);
  private authService = inject(AuthService);
  private featureFlagsStore = inject(FeatureFlagsStore);

  loginAttempted$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loginAttempted),
      switchMap((data) => {
        this.authService.clearStorage();
        return this.authService.login(data.payload).pipe(
          map((res: any) => loginSuccessful({ payload: res })),
          catchError((res) => of(loginFailed({ payload: res }))),
        );
      }),
    ),
  );

  loginSuccessful$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loginSuccessful),
      switchMap((res: any) => {
        this.authService.redirect(res);
        return of({ type: '[Auth API] Redirect Successful' });
      }),
    ),
  );

  ssoLogin$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ssoLogin),
      switchMap((data) => {
        return this.authService
          .ssoLogin(data.payload)
          .pipe(map(() => ssoLoginSuccessful({ payload: data.payload })));
      }),
    ),
  );

  resetFeatureFlagsOnAuth$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(loginAttempted, logoutSuccessful),
        tap(() => this.featureFlagsStore.reset()),
      ),
    { dispatch: false },
  );
}
